import { NotificationFrequency, NotificationTypeShown, UserConfig } from "../contexts/authContext";
import { getUserConfig, setUserConfigIdb } from "../database/indexedDbReadWrite"
import { Option } from "../components/shared/selectInput/types/selectInputProps";

export const getOrInitializeUserConfig = (username: string) => {
    return new Promise((resolve) => {
        getUserConfig(username)
        .then((res: any) => {
            var result: any;
            if (!res) {
                result = { username: username, name: "", config: DefaultUserConfig };
                initializeDefaultUserConfig(username);
            } else { result = res }
            resolve(result);
        })
    })
}

const initializeDefaultUserConfig = (username: string) => {  
    setUserConfigIdb({ username: username, name: "", config: DefaultUserConfig });
}

export const DefaultUserConfig: UserConfig = {
    rememberLogInDetails: false,
    automaticOnlineMode: true,
    checkForUpdates: {
        onOnlineToggle: true,
        onStartUp: true
    },
    notificationFrequency: NotificationFrequency.Every5min,
    notificationTypeShown: NotificationTypeShown.All,
    tableSettings: []
};

export const handleRememberLogInDetailsToggle = (flag: boolean) => {
    if (!flag) unRememberMe();
}

export const unRememberMe = () => {
    localStorage.removeItem("remberMeSOPO");
    localStorage.removeItem("userNameSOPO");
    localStorage.removeItem("passwordSOPO");
}

export const updateOptions: Option[] = [
    { name: "przy zmianie trybu na online", value: 0 },
    { name: "przy uruchomieniu aplikacji", value: 1 }
]

export const notificationFrequency: Option[] = [
    { name: "co 5 min.", value: NotificationFrequency.Every5min },
    { name: "co 15 min.", value: NotificationFrequency.Every15min },
    { name: "co 1 godz.", value: NotificationFrequency.EveryHour }
]

export const notificationTypeShown: Option[] = [
    { name: "wszystkie", value: NotificationTypeShown.All },
    { name: "tylko nieodczytane", value: NotificationTypeShown.Unread },
    { name: "wszystkie z ostatnich 14 dni", value: NotificationTypeShown.Last14Days }
]

export const YesNoOptions: Option[] = [
    { name: "Tak", value: 1 },
    { name: "Nie", value: 0 }
]